<template>
  <div class="form-container">
    <b-message v-if="error && error.non_field_errors" type="is-danger">
      <ul>
        <li v-for="error in this.error.non_field_errors" :key="error">{{ error }}</li>
      </ul>
    </b-message>
    <b-field :label="newPasswordLabel"
             :type="checkType(error, 'new_password2')"
             :message="displayError(error, 'new_password2')"
             class="field-container">
      <password-field name="password"
                      @keyup.native.enter="handlePasswordChange"
                      @input="handleChangeNewPassword">
      </password-field>
    </b-field>
    <div class="button-section">
      <button :disabled="!password" class="button is-primary" @click="handlePasswordChange">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</template>

<script>

import PasswordField from 'top20common/components/form/PasswordField';
import errorsMixins from 'top20common/distribution/mixins/errorsMixin';
export default {
  mixins: [errorsMixins],
  props: {
    hasPassword: Boolean,
    handlePasswordChange: Function,
    handleChangeNewPassword: Function,
    error: Object,
    password: String
  },
  computed: {
    newPasswordLabel() {
      return this.hasPassword ? this.$gettext('New Password') : this.$gettext('Password');
    },
    buttonLabel() {
      return this.hasPassword ? this.$gettext('Change') : this.$gettext('Create');
    }
  },
  components: {
    PasswordField
  }
};
</script>

<style scoped lang="scss">
.form-container {
  margin-top: 25px;
}
.button-section {
  padding-top: 13px;
}
</style>
